import { Injectable } from '@angular/core';
import { APIService } from './api/api.service';
import { ErrorCode } from './api/errorCodes';
import { ModalService } from './gui/modal/modal.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  isErrorModalVisible = false;
  isUncaughtErrorModalVisible = false;
  isForbiddenErrorModalVisible = false;
  ERRORENUM = ErrorCode;

  constructor(
    private modalService: ModalService,
    private apiService: APIService
  ) {}

  errorHandler(error: any) {
    if (error.code === 911) {
      console.warn('View destroyed 911');
      return;
    }
    if (error.status === 401) {
      // TODO this error destroys password reset process
      this.apiService.logout();
      return;
    }

    // if error is JWT error do nothing
    if (error && error.error && error.error.errorCode && error.error.errorCode === this.ERRORENUM.INVALID_JWT_TOKEN) {
      return;
    }

    const errSplit = error?.error?.error?.split('x');
    let errorCode: string;
    let errorString: string;

    if (errSplit) {
      if (errSplit.length >= 1) {
        errorCode = error?.error?.error?.split('x')[0];
      }
      if (errSplit.length >= 2) {
        errorString = error?.error?.error;
      }
    }

    if (!this.isErrorModalVisible) {
      this.isErrorModalVisible = true;
      this.modalService
        .error({
          statuscode: error?.error?.status,
          statustext: error?.statusText,
          errorcode: errorCode,
          errorstring: errorString,
          message: error?.error?.message,
          title: 'Error',
          modalOptions: { size: 'lg' },
        })
        .then(() => {
          this.isErrorModalVisible = false;
        })
        .catch(() => {
          this.isErrorModalVisible = false;
        });
    }
    console.error(error);
  }

  errorHandlerUncaught(error: any) {
    if (error?.status) {
      if (error.status === 401) {
        this.apiService.logout();
        return;
      }

      // if error is JWT error do nothing
      if (error && error.error && error.error.errorCode && error.error.errorCode === this.ERRORENUM.INVALID_JWT_TOKEN) {
        return;
      }
      const errSplit = error?.error?.error?.split('x');
      let errorCode: string;
      let errorString: string;

      if (errSplit) {
        if (errSplit.length >= 1) {
          errorCode = error?.error?.error?.split('x')[0];
        }
        if (errSplit.length >= 2) {
          errorString = error?.error?.error;
        }
      }

      if (!this.isUncaughtErrorModalVisible) {
        this.isUncaughtErrorModalVisible = true;
        this.modalService
          .errorUncaught({
            statuscode: error?.error?.status,
            statustext: error?.statusText,
            errorcode: errorCode,
            errorstring: errorString,
            message: error?.error?.message,
            url: error?.url ?? undefined,
            title: 'Error',
            modalOptions: { size: 'lg' },
          })
          .then(() => {
            this.isUncaughtErrorModalVisible = false;
          })
          .catch(() => {
            this.isUncaughtErrorModalVisible = false;
          });
      }
    }
    console.error(error);
  }

  errorHandlerForbidden(error: any) {
    const errSplit = error?.error?.error?.split('x');
    let errorCode;
    let errorString;

    if (errSplit) {
      if (errSplit.length >= 1) {
        errorCode = error?.error?.error?.split('x')[0];
      }
      if (errSplit.length >= 2) {
        errorString = error?.error?.error;
      }
    }

    if (!this.isForbiddenErrorModalVisible) {
      this.isForbiddenErrorModalVisible = true;
      this.modalService
        .errorForbidden({
          statuscode: error?.error?.status,
          statustext: error?.statusText,
          errorcode: errorCode,
          errorstring: errorString,
          message: error?.error?.message,
          title: 'Error',
          modalOptions: { size: 'lg' },
        })
        .then(() => {
          this.isForbiddenErrorModalVisible = false;
        })
        .catch(() => {
          this.isForbiddenErrorModalVisible = false;
        });
    }
    console.error(error);
  }
}
